import { render, staticRenderFns } from "./Quota.vue?vue&type=template&id=71c6bb46&scoped=true&"
import script from "./Quota.vue?vue&type=script&lang=js&"
export * from "./Quota.vue?vue&type=script&lang=js&"
import style0 from "./Quota.vue?vue&type=style&index=0&id=71c6bb46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c6bb46",
  null
  
)

export default component.exports